import React from "react";
import Logo from "./Logo";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import MuiAppBar from "@mui/material/AppBar";
import {useTheme} from "@mui/material/styles";
import QuickAccessButton from "./QuickAccessButton";
import {SkipLinks} from "../../fundamentals/SkipLinks";
import {toolbarSx} from "./core/navigationStyles";

interface Props {
    navigation: any,
    page: any,
}

function LogoOnlyNavigation(props: Props) {
    const theme = useTheme();

    const muiAppBarSx = {
        mt: 0,
        height: {xs: 70, lg: 72},
        display: 'flex',
        paddingLeft: '0!important',
        paddingRight: '0!important',
        paddingTop: 0,
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--background-white)',
        color: theme.palette.text.primary,
        boxShadow: 'none',
        borderTop: '1px solid #e0e0e0',
        borderBottom: '1px solid #e0e0e0'
    };

    return <MuiAppBar component="div" sx={muiAppBarSx} position={"sticky"}>
        <SkipLinks isWithoutTopNavi isWithoutNavi/>
        <Container maxWidth={false}
                   sx={{
                       display: 'flex',
                       justifyContent: 'center',
                       width: '100%',
                       padding: '0 24px !important',
                   }}>
            <Toolbar disableGutters sx={toolbarSx}>
                <Logo navigation={props.navigation}/>
                <QuickAccessButton fullWidth={false} page={props.page}/>
            </Toolbar>
        </Container>
    </MuiAppBar>
}

export default LogoOnlyNavigation